import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import green from "@material-ui/core/colors/green";
import amber from "@material-ui/core/colors/amber";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";


const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing()
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

export function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired
};

export const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
  margin: {
    margin: theme.spacing()
  }
});

export const CustomizedSnackbars = (props) => {

  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    const { actions } = props;
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    if (actions) {
      actions.clearMessage();
    }
  };

  const { text, type } = props;
  const autoHideDuration = props.autoHideDuration || null;
  return (
    <Snackbar
      autoHideDuration={autoHideDuration}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      open={open}
      onClose={handleClose}
    >
      <MySnackbarContentWrapper
        onClose={handleClose}
        variant={type}
        message={text}
      />
    </Snackbar>
  );
}

CustomizedSnackbars.propTypes = {
  classes: PropTypes.object.isRequired
};

const Toaster = withStyles(styles2)(CustomizedSnackbars);

export default Toaster;


// import React from "react";
// import PropTypes from "prop-types";
// import classNames from "classnames";
// import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// import ErrorIcon from "@material-ui/icons/Error";
// import InfoIcon from "@material-ui/icons/Info";
// import CloseIcon from "@material-ui/icons/Close";
// import green from "@material-ui/core/colors/green";
// import amber from "@material-ui/core/colors/amber";
// import IconButton from "@material-ui/core/IconButton";
// import Snackbar from "@material-ui/core/Snackbar";
// import SnackbarContent from "@material-ui/core/SnackbarContent";
// import WarningIcon from "@material-ui/icons/Warning";
// import { withStyles } from "@material-ui/core/styles";

// const variantIcon = {
//   success: CheckCircleIcon,
//   warning: WarningIcon,
//   error: ErrorIcon,
//   info: InfoIcon
// };

// const styles1 = theme => ({
//   success: {
//     backgroundColor: green[600]
//   },
//   error: {
//     backgroundColor: theme.palette.error.dark
//   },
//   info: {
//     backgroundColor: theme.palette.primary.dark
//   },
//   warning: {
//     backgroundColor: amber[700]
//   },
//   icon: {
//     fontSize: 20
//   },
//   iconVariant: {
//     opacity: 0.9,
//     marginRight: theme.spacing()
//   },
//   message: {
//     display: "flex",
//     alignItems: "center"
//   }
// });

// function MySnackbarContent(props) {
//   const { classes, className, message, onClose, variant, ...other } = props;
//   const Icon = variantIcon[variant];

//   return (
//     <SnackbarContent
//       className={classNames(classes[variant], className)}
//       aria-describedby="client-snackbar"
//       message={
//         <span id="client-snackbar" className={classes.message}>
//           <Icon className={classNames(classes.icon, classes.iconVariant)} />
//           {message}
//         </span>
//       }
//       action={[
//         <IconButton
//           key="close"
//           aria-label="Close"
//           color="inherit"
//           className={classes.close}
//           onClick={onClose}
//         >
//           <CloseIcon className={classes.icon} />
//         </IconButton>
//       ]}
//       {...other}
//     />
//   );
// }

// MySnackbarContent.propTypes = {
//   classes: PropTypes.object.isRequired,
//   className: PropTypes.string,
//   message: PropTypes.node,
//   onClose: PropTypes.func,
//   variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired
// };

// const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

// const styles2 = theme => ({
//   margin: {
//     margin: theme.spacing()
//   }
// });

// class CustomizedSnackbars extends React.Component {
//   state = {
//     open: true
//   };

//   handleClick = () => {
//     this.setState({ open: true });
//   };

//   handleClose = (event, reason) => {
//     const { actions } = this.props;
//     if (reason === "clickaway") {
//       return;
//     }
//     this.setState({ open: false });
//     actions.clearMessage();
//   };

//   render() {
//     const { text, type } = this.props;
//     const autoHideDuration = this.props.autoHideDuration || null;
//     return (
//       <Snackbar
//         autoHideDuration={autoHideDuration}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "center"
//         }}
//         open={this.state.open}
//         onClose={this.handleClose}
//       >
//         <MySnackbarContentWrapper
//           onClose={this.handleClose}
//           variant={type}
//           message={text}
//         />
//       </Snackbar>
//     );
//   }
// }

// CustomizedSnackbars.propTypes = {
//   classes: PropTypes.object.isRequired
// };

// const Toaster = withStyles(styles2)(CustomizedSnackbars);

// export default Toaster;
